import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { ISchema } from "../../validation-types/SchemaDefinition";

export const getEmployeeRequirementsLinks = (axios: IAxiosInstance) => {
  return async (
    params: ISchema["#/definitions/IGetEmployeeRequirementLinksParams"]
  ) => {
    const response = await axios.noRetry.get<
      ISchema["#/definitions/IGetEmployeeRequirementLinksResponse"]
    >(`/api/getEmployeeRequirementLinks`, { params });
    const resData = response.data;

    if (resData.success) {
      return resData.data;
    }

    throw new Error("Something went wrong");
  };
};
